import { SearchStation } from 'dataSources/Typicode/stations/types';
import { IStation } from 'dataSources/Typicode/stations/types';

import { IStationMap } from '../types/stationMap';

import { BBox } from '@turf/helpers';
import turfBbox from '@turf/bbox';
import {
  reduceAsync,
  isActionItem,
  defaultBBox,
  turfLineString,
} from 'common/utils';

interface MappingStationResult {
  stations: IStation[];
  actionStations: IStation[];
  stationsBBox: BBox;
  actionStationsBBox: BBox;
  serviceCodes: number[];
}

interface ReduceResult
  extends Pick<MappingStationResult, 'stations' | 'actionStations'> {
  stationCoords: [
    IStation['coordinates']['longitude'],
    IStation['coordinates']['latitude'],
  ][];
  actionStationCoords: [
    IStation['coordinates']['longitude'],
    IStation['coordinates']['latitude'],
  ][];
  serviceCodes: number[];
}

export const mappingStationsByCode = async (
  data: SearchStation[],
  allStationsMap: IStationMap,
  prevStations: IStation[],
) => {
  const result = await reduceAsync<SearchStation, ReduceResult>(
    data,
    (acc, stationCode) => {
      const item = allStationsMap[stationCode.code];
      if (item && item.code && item.coordinates) {
        const foundStation =
          prevStations.find(({ code }) => code === item.code) || item;

        const prevStation = { ...foundStation, ...stationCode };

        acc.stations.push(prevStation);

        acc.stationCoords.push([
          prevStation.coordinates.longitude,
          prevStation.coordinates.latitude,
        ]);

        if (isActionItem(prevStation)) {
          acc.actionStations.push(prevStation);
          acc.actionStationCoords.push([
            prevStation.coordinates.longitude,
            prevStation.coordinates.latitude,
          ]);
        }
        item.roadsideServiceCodes.forEach((code) => {
          if (!acc.serviceCodes.has(code)) {
            acc.serviceCodes.set(code);
          }
        });
      }
      return acc;
    },
    {
      stations: [],
      actionStations: [],
      stationCoords: [],
      actionStationCoords: [],
      serviceCodes: new Map(),
    },
  );

  return {
    ...result,
    stationsBBox: turfBbox(turfLineString(result.stationCoords)),
    actionStationsBBox:
      result.actionStationCoords.length > 2
        ? turfBbox(turfLineString(result.actionStationCoords))
        : defaultBBox,
    serviceCodes: Array.from(result.serviceCodes.keys()),
  };
};
